import { render, staticRenderFns } from "./AzGroupsReadOnly.vue?vue&type=template&id=04820726"
import script from "./AzGroupsReadOnly.vue?vue&type=script&lang=js"
export * from "./AzGroupsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports